// extracted by mini-css-extract-plugin
export default {"benefits":"OxhMs","title":"l6MNZ","odd":"_8Qpn","even":"dnWur","grid":"tFhKm","imageContainer":"bmO5b","image":"sUJM2","text":"Z1gRI"};